import { Helmet } from "react-helmet-async"
import {
	ITransportServiceProvider,
	TransportServiceProviderBookings,
} from "../../../../../TransportServiceProviders"
import { useOutletContext } from "react-router"

export default function TransportServiceProviderBookingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ITransportServiceProvider
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Bookings | TSP</title>
			</Helmet>
			<TransportServiceProviderBookings
				transportServiceProvider={transportServiceProvider}
			/>
		</>
	)
}
